<div class="my-1">
  <span>
    <strong>Encounter Date {{ position + 1 }}</strong>
  </span>
  <div class="d-flex flex-row flex-wrap align-items-center specialist-encounter-verification">
    <div class="input-group w-auto encounter-date">
      <input
        name="encounterDate"
        class="form-control encounter-date-input"
        type="date"
        autocomplete="off"
        [(ngModel)]="encounterDate"
        [disabled]="disabled"
        (blur)="onEncounterDateBlur()"
        placeholder="MM/DD/YYYY"
        />
    </div>
    @if (canRemove) {
      <div class="actions ms-1">
        <a href="#/remove" class="text-danger ms-1 text-small" (click)="onRemoveClick($event)">Remove</a>
      </div>
    }
  </div>
</div>
